const creditEvaluationPublicity = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditEvaluationPublicity')), 'creditEvaluationPublicity');
const childRouterIndex = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/childRouterIndex')), 'childRouterIndex');

//  物业服务企业相关页面
const companyBaseInfoList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyBaseInfoList')), 'companyBaseInfoList');
const companyBaseInfoDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyBaseInfoDetail')), 'companyBaseInfoDetail');
const companyBaseInfoDetailPenetrate = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyBaseInfoDetailPenetrate')), 'companyBaseInfoDetailPenetrate');
const companyGoodInfoList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyGoodInfoList')), 'companyGoodInfoList');
const companyGoodInfoDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyGoodInfoDetail')), 'companyGoodInfoDetail');
const companyBadInfoList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyBadInfoList')), 'companyBadInfoList');
const companyBadInfoDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyPage/companyBadInfoDetail')), 'companyBadInfoDetail');

//  项目负责人相关页面
const managerBaseInfoList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerBaseInfoList')), 'managerBaseInfoList');
const managerBaseInfoDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerBaseInfoDetail')), 'managerBaseInfoDetail');
const managerBaseInfoDetailPenetrate = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerBaseInfoDetailPenetrate')), 'managerBaseInfoDetailPenetrate');
const managerGoodInfo = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerGoodInfo')), 'managerGoodInfo');
const managerGoodInfoDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerGoodInfoDetail')), 'managerGoodInfoDetail');
const managerBadInfo = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerBadInfo')), 'managerBadInfo');
const managerBadInfoDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/managerPage/managerBadInfoDetail')), 'managerBadInfoDetail');

//  风险名单相关页面
const companyRiskList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/riskList/companyRiskList')), 'companyRiskList');
const companyRiskDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/riskList/companyRiskDetail')), 'companyRiskDetail');
const managerRiskList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/riskList/managerRiskList')), 'managerRiskList');
const managerRiskDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/riskList/managerRiskDetail')), 'managerRiskDetail');

//  信用等级评价相关页面
const companyRatingEvaluationList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/companyRatingEvaluationList')), 'companyRatingEvaluationList');
const companyRatingEvaluationDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/companyRatingEvaluationDetail')), 'companyRatingEvaluationDetail');
const companyCreditRatingBase = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/companyCreditRatingBase')), 'companyCreditRatingBase');
const managerRatingEvaluationList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/managerRatingEvaluationList')), 'managerRatingEvaluationList');
const managerRatingEvaluationDetail = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/managerRatingEvaluationDetail')), 'managerRatingEvaluationDetail');
const managerCreditRatingBase = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/managerCreditRatingBase')), 'managerCreditRatingBase');
const creditRatingEvaluationPenetrate = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/creditRatingEvaluation/creditRatingEvaluationPenetrate')), 'creditRatingEvaluationPenetrate');



//  红名单相关页面
const companyRedList = r => require.ensure([], () => r(require('@/page/creditEvaluationPublicity/companyRedList/companyRedList')), 'companyRedList');


const creditEvaluationPublicityRouter = {
    path: '',
    name: '物业服务信息评价公示',
    component: creditEvaluationPublicity,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive:false,
    },
    children: [
        {
            path: '',
            name: '物业服务企业信息公示',
            component: childRouterIndex,
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:false,
            },
            // 物业服务企业基础信息
            // 物业服务企业良好信息
            // 物业服务企业不良信息
            children: [
                 {
                    path: '/companyBaseInfoList',
                    component: companyBaseInfoList,
                    name: '物业服务企业基础信息',
                    meta: {
                        right: ['物业服务企业基础信息'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                 {
                    path: '/companyBaseInfoDetail',
                    component: companyBaseInfoDetail,
                    name: '物业服务企业基础详情',
                    meta: {
                        right: ['物业服务企业基础详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyBaseInfoDetailPenetrate',
                    component: companyBaseInfoDetailPenetrate,
                    name: '物业项目基础信息详情',
                    meta: {
                        right: ['物业项目基础信息详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyGoodInfoList',
                    component: companyGoodInfoList,
                    name: '物业服务企业良好信息',
                    meta: {
                        right: ['物业服务企业良好信息'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyGoodInfoDetail',
                    component: companyGoodInfoDetail,
                    name: '物业服务企业良好信息详情',
                    meta: {
                        right: ['物业服务企业良好信息详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyBadInfoList',
                    component: companyBadInfoList,
                    name: '物业服务企业不良信息',
                    meta: {
                        right: ['物业服务企业不良信息'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyBadInfoDetail',
                    component: companyBadInfoDetail,
                    name: '物业服务企业不良信息详情',
                    meta: {
                        right: ['物业服务企业不良信息详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
            ]
        },
        {
            path: '',
            name: '项目负责人信息公示',
            component: childRouterIndex,
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:false,
            },
            // 项目负责人基础信息
            // 项目负责人良好信息
            // 项目负责人不良信息
            children: [
                {
                    path: '/managerBaseInfoList',
                    component: managerBaseInfoList,
                    name: '项目负责人基础信息',
                    meta: {
                        right: ['项目负责人基础信息'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerBaseInfoDetail',
                    component: managerBaseInfoDetail,
                    name: '项目负责人基础详情',
                    meta: {
                        right: ['项目负责人基础详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerBaseInfoDetailPenetrate',
                    component: managerBaseInfoDetailPenetrate,
                    name: '项目负责人信息详情',
                    meta: {
                        right: ['项目负责人信息详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerGoodInfo',
                    component: managerGoodInfo,
                    name: '项目负责人良好信息',
                    meta: {
                        right: ['项目负责人良好信息'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerGoodInfoDetail',
                    component: managerGoodInfoDetail,
                    name: '项目负责人良好信息详情',
                    meta: {
                        right: ['项目负责人良好信息详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerBadInfo',
                    component: managerBadInfo,
                    name: '项目负责人不良信息',
                    meta: {
                        right: ['项目负责人不良信息'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerBadInfoDetail',
                    component: managerBadInfoDetail,
                    name: '项目负责人不良信息详情',
                    meta: {
                        right: ['项目负责人不良信息详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
            ]
        },
        {
            path: '',
            name: '风险名单公示',
            component: childRouterIndex,
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:false,
            },
            // 物业服务企业风险名单
            // 项目负责人风险名单
            children: [
                {
                    path: '/companyRiskList',
                    component: companyRiskList,
                    name: '物业服务企业风险名单',
                    meta: {
                        right: ['物业服务企业风险名单'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyRiskDetail',
                    component: companyRiskDetail,
                    name: '物业服务企业风险名单详情',
                    meta: {
                        right: ['物业服务企业风险名单详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerRiskList',
                    component: managerRiskList,
                    name: '项目负责人风险名单',
                    meta: {
                        right: ['项目负责人风险名单'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerRiskDetail',
                    component: managerRiskDetail,
                    name: '项目负责人风险名单详情',
                    meta: {
                        right: ['项目负责人风险名单详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
            ]
        },
        {
            path: '',
            name: '评价情况公示',
            component: childRouterIndex,
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:false,
            },
            // 物业服务企业评价情况
            // 项目负责人评价情况
            children: [
                {
                    path: '/companyRatingEvaluationList',
                    component: companyRatingEvaluationList,
                    name: '物业服务企业评价情况',
                    meta: {
                        right: ['物业服务企业评价情况'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/historyCompanyEvaluationList',
                    component: companyRatingEvaluationList,
                    name: '物业服务企业历史评价情况',
                    meta: {
                        right: ['物业服务企业历史评价情况'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/companyRatingEvaluationDetail',
                    component: companyRatingEvaluationDetail,
                    name: '企业榜单详情',
                    meta: {
                        right: ['企业榜单详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                  path: '/companyCreditRatingBase',
                  component: companyCreditRatingBase,
                  name: '物业服务企业基础详情',
                  meta: {
                      right: ['物业服务企业基础详情'],
                      isShowMenu: false,
                      keepAlive:false,
                      t:Date.now()
                  },
                },
                {
                    path: '/managerRatingEvaluationList',
                    component: managerRatingEvaluationList,
                    name: '项目负责人评价情况',
                    meta: {
                        right: ['项目负责人评价情况'],
                        isShowMenu: true,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/historyManagerEvaluationList',
                    component: managerRatingEvaluationList,
                    name: '项目负责人历史评价情况',
                    meta: {
                        right: ['项目负责人历史评价情况'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                    path: '/managerRatingEvaluationDetail',
                    component: managerRatingEvaluationDetail,
                    name: '负责人榜单详情',
                    meta: {
                        right: ['负责人榜单详情'],
                        isShowMenu: false,
                        keepAlive:false,
                        t:Date.now()
                    },
                },
                {
                  path: '/managerCreditRatingBase',
                  component: managerCreditRatingBase,
                  name: '项目负责人基础详情',
                  meta: {
                      right: ['项目负责人基础详情'],
                      isShowMenu: false,
                      keepAlive:false,
                      t:Date.now()
                  },
                },
                {
                  path: '/creditRatingEvaluationPenetrate',
                  component: creditRatingEvaluationPenetrate,
                  name: '物业项目基础信息详情',
                  meta: {
                      right: ['物业项目基础信息详情'],
                      isShowMenu: false,
                      keepAlive:false,
                      t:Date.now()
                  },
                },
                
            ]
        },
        {
            path: '',
            name: '激励名单',
            component: childRouterIndex,
            meta: {
                right: [],
                isShowMenu: true,
            },
            children: [
                {
                    path: '/companyRedList',
                    component: companyRedList,
                    name: '企业激励名单',
                    meta: {
                        right: ['企业激励名单'],
                        isShowMenu: true
                    },
                },
            ]
        },
    ]
};
export default creditEvaluationPublicityRouter;